import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TenantService } from "../services/tenant.service";
import { UserService } from "../domain/user-service";
import { RoleNames } from "../domain/user";

@Injectable()
export class UsersManagerGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().hasManageUsersPermission;
  }
}
@Injectable()
export class MediaTranscoderGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().hasEditMediaTranscodingPermission;
  }
}
@Injectable()
export class MAMEditorGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().hasEditMAMPermission;
  }
}

@Injectable()
export class RecordingManagerGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().hasRecordingPermission;
  }
}

@Injectable()
export class BatchUploadGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().hasBatchUploadPermission;
  }
}

@Injectable()
export class SuperUserGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().isSuperUser;
  }
}

@Injectable()
export class LiveManagerGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().isLiveManager;
  }
}
@Injectable()
export class ChannelCreatorGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().canCreateChannels;
  }
}
@Injectable()
export class ContentManagerGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().isContentControlManager;
  }
}

@Injectable()
export class BroadcastsManagerGuard {
  constructor(private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.userService.getCurrentUser().isBroadcastsManager;
  }
}
